export default "__VITE_ASSET__DvTpQfMb__"